import { createReducer, on } from '@ngrx/store';
import { DattoConfig } from '@octiga/psa/datto.interface';
import { deleteMspDattoIntegrationSuccess } from '../credentials/actions';
import * as actions from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'mspDattoConfig';

export interface State extends Status {
    data: DattoConfig | null;
}

export const initialState: State = {
    data: null,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,
    on(actions.loadMspDattoConfig, (state) => ({ ...state, loading: true })),
    on(actions.loadMspDattoConfigSuccess, (state, { data }) => ({ ...state, data, loaded: true, loading: false })),
    on(actions.loadMspDattoConfigFailure, (state, { error }) => ({ ...state, error, loading: false })),

    on(actions.updateMspDattoConfigSuccess, (state) => ({ ...state })),
    on(deleteMspDattoIntegrationSuccess, () => initialState),
);

export const selectData = (state: State) => state.data;
